import { useFormikContext } from 'formik';
import React, { useState } from 'react';
import 'react-phone-number-input/style.css';
import PhoneInput from 'react-phone-number-input';
import ErrorMessage from '../ErrorrMessage';
import styles from './TextField.module.css';
import { labelName } from '../../../utils/functions';
import {number} from "yup/lib/locale";
import LocationInput from "../Location/LocationInput";

export default function TextField({
  field_label,
  field_type,
  currency,
  parent,
  isRequired,
}) {
  const {getFieldProps} = useFormikContext();
  const name = parent ? `${parent}.fields.${field_label}` : field_label;

  const [value, setValue] = useState('');
  const checkDefaultType = (type) => {
    if (type && type.toLowerCase()?.includes('radio')) return 'radio';
    if (type && type.toLowerCase()?.includes('number')) return 'number';
    if (type && type.toLowerCase()?.includes('date')) return 'date';
    if (type && type.toLowerCase()?.includes('checkbox')) return 'checkbox';
    if (type && type.toLowerCase()?.includes('text')) return 'text';
    if (type && type.toLowerCase()?.includes('email')) return 'email';
    if (type && type.toLowerCase()?.includes('datetime')) return 'datetime';
    if (type && type.toLowerCase()?.includes('url')) return 'url';
    if (type && type.toLowerCase()?.includes('hidden')) return 'hidden';
    if (type && type.toLowerCase()?.includes('file')) return 'file';
    if (type && type.toLowerCase()?.includes('month')) return 'month';
    if (type && type.toLowerCase()?.includes('week')) return 'week';
    return type;
  };

  if (field_type == "location" && isRequired) {
    return <LocationInput name={name} type={field_type} className={styles.input} isRequired={isRequired} />;
  }
  return (
    <div className={styles.inputContainer}>
      <label className={styles.label}>
        {field_label == 'address_line_2' ? 'Address' : labelName(field_label)}
        {isRequired === 'true' && (
          <span style={{ color: '#d32f2f', padding: 0 }}>*</span>
        )}
      </label>
      {field_label === 'phone_number' && (
        <PhoneInput
          international
          countryCallingCodeEditable={false}
          defaultCountry="RU"
          className={[styles.PhoneInput, styles.input]}
          {...getFieldProps(name)}
        />
      )}
      {!currency && field_label !== 'phone_number' && (
        <>
          <input
            className={styles.input}
            type={field_type && checkDefaultType(field_type)}
            {...getFieldProps(name)}
          />
        </>
      )}

      {currency && (
        <div className={styles.currency}>
          <input
            className={styles.input}
            type={field_type && field_type}
            {...getFieldProps(name)}
          />
          <span>{currency}</span>
        </div>
      )}

      <ErrorMessage name={name} parent={parent} />
    </div>
  );
}
